exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Ck9g3lqTOcOfnJjGKFEv8 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99;\n  background-color: rgba(9,30,66,0.8);\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  opacity: 1;\n  transition: all 0.8s ease-in;\n}\n._3nTcJhqo36xwOujhYlW2XQ {\n  font-size: 2rem;\n  color: #fafbfc;\n}\n.AvrRRWBK1wpL7OB74U3pt {\n  opacity: 0;\n}\n", ""]);
// Exports
exports.locals = {
	"main": "_3Ck9g3lqTOcOfnJjGKFEv8",
	"label": "_3nTcJhqo36xwOujhYlW2XQ",
	"animationOut": "AvrRRWBK1wpL7OB74U3pt"
};